$(document).on('turbolinks:load', function() {
  $(".notes-field").hide();
  // $(".post-labels").hide();

  initializeSelect2Filters()
  let url = new URL(window.location.href);

  $('#project_posts_csv_export').click(function(e){
    e.preventDefault();

    if (confirm('Are You Sure?')){
      $(this).addClass( "disabled" );
    }
    else {
      return false;
    }

  })

  $('body').on("submit", ".post_label_form", function(e) {
    $(this).hide();

    var id = $(this).attr("id");
    $('#form_alert_' + id).show();
  })

  $('body').on("submit", ".user_post_label_form", function(e) {
    $(this).hide();

    var id = $(this).attr("id");
    $('#form_alert_' + id).show();
  })

  if(url.searchParams.get('view') == "label_unmarked" || url.searchParams.get('view') == "relevance") {
    $('.post-list').on('click', '.relevance-btn', function() {
      id_attr = $(this).attr("id")
      id_attr = String(id_attr)
      id = id_attr.split("relevant_")[1]
  
      if ($('#video-'+id) && $('#video-'+id)[0]) {
        $('#video-'+id)[0].pause();
      }
  
      Rails.fire(this.form, "submit");
  
      var div = $('#overlay-'+id);
      div.show();
  
      if(id_attr.includes("not_relevant")){
        div.css("background-color", "rgba(189, 6, 0, 0.5)");
        div.find('.not-relevant').show()
      } 
      else if(id_attr.includes("relevant")) {
        div.css("background-color", "rgba(40, 173, 0, 0.5)");
        div.find('.relevant').show()
      }
    });
  }

  $('body').on('click', '.modify-btn', function(){
    id = $(this).attr("id")
    id = id.split("modify-")[1]

    var div = $('#overlay-'+id)
    div.find('.not-relevant').hide()
    div.find('.relevant').hide()
    div.hide();
    $("form#"+id).show();
    $("#form_alert_" +id).hide();
  })

  $('body').on('click', '.toggle-post-labels-link', function(e){
    e.preventDefault();
    id = $(this).attr("id")
    id = id.split("toggle-post-labels-")[1]

    var div = $('#post-labels-'+id)
    div.toggleClass("d-none");
  })

  $('body').on('click', '.form-alert-link', function(e){
    e.preventDefault();

    var id = $(this).attr("id").split("view_form_")[1];

    $("form#"+id).show();
    $("#form_alert_" +id).hide();
  });

  $('.enable-notes').change(function(){
    var checked = $(this).prop('checked');
    var id = $(this).attr('id').split("notes_checkbox_")[1];

    if (checked) {
      $('#notes_field_' + id).show();
    } else {
      $('#notes_field_' + id).hide();
    }

  });

  $('#expand_labels').change(function(){
    var checked = $(this).prop('checked');
    let url = new URL(window.location.href);
    if (checked) {
      $('.label-children').show();
      url.searchParams.set("expand_labels", true)
    } else {
      $('.label-children').hide();
      url.searchParams.delete("expand_labels")
    }
    window.location.href = url.href;
  });

  enableViewControls()
});

function enableViewControls(){
  let url = new URL(window.location.href);

  if (url.searchParams.get('view') == "label_unmarked") {
    $('#showRelevanceForm').prop('checked', true)
  } else if (url.searchParams.get('view') == "label_relevant") {
    $('#showLabelsForm').prop('checked', true)
  } else if (url.searchParams.get('view') == "label_full") { 
    $('#showFullLabelForm').prop('checked', true)
  } else {
    $('#showPosts').prop('checked', true)
  }

  if (url.searchParams.get('my_labels') == "true"){
    $("#labeled").prop("checked", true);
  } else if (url.searchParams.get('my_labels') == "false") {
    $("#notLabeled").prop("checked", true);
  } else {
    $("#all").prop("checked", true);
  }

  $('.radio-control').change(function(){
    div_name = $(this).attr("name")
    id = div_name.split("optradio-")[1]

    if (this.id == 'labeled') {
      url.searchParams.set("labeler", id)
      url.searchParams.set("relevant", "NOT_NULL")
      url.searchParams.set("my_labels", "true")
    }
    else if (this.id == 'notLabeled') {
      url.searchParams.set("labeler", id)
      url.searchParams.set("relevant", "NULL")
      url.searchParams.set("my_labels", "false")
    } else {
      url.searchParams.delete("labeler")
      url.searchParams.delete("relevant")
      url.searchParams.delete("my_labels")
    }

    window.location.href = url.href;
  })


  $('#showPosts').change(function(){
    var checked = $(this).prop('checked');

    if (checked) {
      updateParams("view", "default")
    } else {
      $('#notes_field_' + id).hide();
    }

  });

  $('#showRelevanceForm').change(function(){
    var checked = $(this).prop('checked');

    if (checked) {
      updateParams("view", "label_unmarked")
    }

  });

  $('#showLabelsForm').change(function(){
    var checked = $(this).prop('checked');

    if (checked) {
      updateParams("view", "label_relevant")
    }

  });

  $('#showFullLabelForm').change(function(){
    var checked = $(this).prop('checked');

    if (checked) {
      updateParams("view", "label_full")
    } 

  });

}

function initializeSelect2Filters(){
  filter_names = ['tags', 'platform-labels', 'agents', 'segments']
  let url = new URL(window.location.href);

  filter_names.forEach((filter_name) => {
    var humanzied_name = capitalize(filter_name.split("-").join(" "));
    var filter_div = $(".project-post-"+filter_name+"-filter")
    var wrapper_div_name = "."+filter_name+"-filter"
    var param_name = filter_name.split("-").join("_");

    filter_div.select2({
      closeOnSelect : false,
      placeholder : "Select " + humanzied_name,
      allowHtml: true,
      allowClear: true
    });
  
    
    var filter_length = 0
    if(filter_div.val()){
      filter_length = filter_div.val().length
    }
  
    filter_div.next(wrapper_div_name + ' span.select2').find('ul').html(function() {
      if(filter_length == 2 || filter_length == 1) {
        names = []
        var vals = filter_div.select2('data');
        vals.forEach(function(obj){ names.push(obj.title) });
        return "<li class='mt-1'><b>" + names.join(", ") + "</b></li>"
      } else {
        return "<li class='mt-1'><b>" + filter_length + "</b> "+humanzied_name+"</li>"
      }
    })
  
    filter_div.on('select2:close', function (e) {
      var new_value = $(this).val().join(',');
      var current_value = (url.searchParams.get(param_name)) ? url.searchParams.get(param_name) : '';
  
      if(new_value != current_value) {
        updateParams(param_name, new_value)
      }
      
    });
  
    filter_div.on('change', function (e) {
      var len = $(this).val().length
  
      $(this).next(wrapper_div_name + ' span.select2').find('ul').html(function() {
        if(len == 2 || len == 1) {
          names = []
          var vals = filter_div.select2('data');
          vals.forEach(function(obj){ names.push(obj.title) });
          return "<li class='mt-1'><b>" + names.join(", ") + "</b></li>"
        } else {
          return "<li class='mt-1'><b>" + len + "</b> "+humanzied_name+"</li>"
        }
      })
    });
  });

}

function updateParams(key, value){
  let url = new URL(window.location.href);

  if(value){
    url.searchParams.set(key, value)

  } else {
    url.searchParams.delete(key)
  }

  window.location.href = url.href;
}

function capitalize(input) {  
  var words = input.split(' ');  
  var CapitalizedWords = [];  
  words.forEach(element => {  
      CapitalizedWords.push(element[0].toUpperCase() + element.slice(1, element.length));  
  });  
  return CapitalizedWords.join(' ');  
}  
